import { supabase } from './supabase';

export async function signInWithMagicLink(email: string) {
  const { error } = await supabase.auth.signInWithOtp({ email, options: { emailRedirectTo: window.location.origin } });
  if (error) throw error;
}

export async function requireSession(): Promise<boolean> {
  const { data } = await supabase.auth.getSession();
  return !!data.session;
}
